import { render, staticRenderFns } from "./ModalServiceCategory.vue?vue&type=template&id=4ae4083e&"
import script from "./ModalServiceCategory.vue?vue&type=script&lang=js&"
export * from "./ModalServiceCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports